import { Box } from '@givebutter/primitives/box';
import { Button } from '@givebutter/primitives/button';
import { show as showIntercomChat } from '@intercom/messenger-js-sdk';

export const SplashScreen = () => (
    <div className="splash-page">
        <div className="main main-tabbed" style={{ marginLeft: '0px' }}>
            <Box className="flex flex-col items-start gap-4 p-8">
                <div>
                    <h1 className="text-2xl font-medium">Chapter Fundraising</h1>
                    <p>
                        Link fully-autonomous, managed sub-accounts.{' '}
                        <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://help.givebutter.com/en/articles/3265130-chapter-nonprofits-national-user-guide"
                        >
                            Learn more
                        </a>
                        .
                    </p>
                </div>
                <Button variant="solid" onClick={() => showIntercomChat()}>
                    Chat with us
                </Button>
            </Box>
            <div className="image">
                <img alt="Illustration" src={`/images/screenshots/chapters.png`} />
            </div>
        </div>
    </div>
);

export default SplashScreen;
